module.exports = __webpack_public_path__ + "media/images/ei-logo-with-text-2b17a96e5a0e6a4740291cf045727bca.svg";